"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _immer = _interopRequireDefault(require("immer"));

var _lodash = require("lodash");

var _Input = _interopRequireDefault(require("../components/Input"));

var _Select = _interopRequireDefault(require("../components/Select"));

var _CmsLayout = _interopRequireDefault(require("../components/CmsLayout"));

var _store = require("../store");

var _actions = require("../actions");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var GeneralSettings = function GeneralSettings() {
  var _site$deployment, _site$deployment2, _site$deployment3, _site$editorOptions, _site$editorOptions$s, _site$editorOptions2, _site$editorOptions2$, _site$editorOptions3, _site$editorOptions3$;

  var _ref = (0, _store.useStore)(),
      _ref2 = _slicedToArray(_ref, 2),
      _ref2$ = _ref2[0],
      config = _ref2$.config,
      _ref2$$cmsState = _ref2$.cmsState,
      sites = _ref2$$cmsState.sites,
      siteID = _ref2$$cmsState.siteID,
      site = _ref2$.editorState.site,
      dispatch = _ref2[1];

  var _ref3 = (0, _react.useState)(null),
      _ref4 = _slicedToArray(_ref3, 2),
      loading = _ref4[0],
      setLoading = _ref4[1];

  (0, _react.useEffect)(function () {
    dispatch({
      type: "ADD_EDITOR_SITE",
      payload: sites[siteID]
    });
  }, []);

  var handleChange = function handleChange(e) {
    var nextSite = (0, _immer.default)(site, function (draft) {
      return (0, _lodash.set)(draft, "".concat(e.target.name), e.target.value);
    });
    dispatch({
      type: "UPDATE_EDITOR_SITE",
      payload: nextSite
    });
  };

  var handleChangeSelect = function handleChangeSelect(value, name) {
    var nextSite = (0, _immer.default)(site, function (draft) {
      return (0, _lodash.set)(draft, "".concat(name), value);
    });
    dispatch({
      type: "UPDATE_EDITOR_SITE",
      payload: nextSite
    });
  };

  var handleUpdate = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args, loader) {
      var id;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              id = site.id;
              setLoading(loader);
              _context.next = 4;
              return _actions.siteActions.updateSite(_objectSpread({
                id: id
              }, args), dispatch, config);

            case 4:
              setLoading(null);

              _antd.message.success('Updated successfully');

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleUpdate(_x, _x2) {
      return _ref5.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react.default.createElement(_CmsLayout.default, {
    pageTitle: "Settings"
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 40
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "General"
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 20
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "Title",
    value: site === null || site === void 0 ? void 0 : site.title,
    name: "title",
    onChange: handleChange
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "Frontend URL",
    value: site === null || site === void 0 ? void 0 : site.siteUrl,
    name: "siteUrl",
    onChange: handleChange
  }), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    loading: loading === 'general',
    onClick: function onClick() {
      return handleUpdate({
        title: site.title,
        siteUrl: site.siteUrl
      }, 'general');
    },
    children: "Update",
    type: "primary"
  }))), /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Deployment"
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 20
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "Build Hook",
    value: site === null || site === void 0 ? void 0 : (_site$deployment = site.deployment) === null || _site$deployment === void 0 ? void 0 : _site$deployment.buildHook,
    name: "deployment.buildHook",
    onChange: handleChange
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "Badge Image",
    value: site === null || site === void 0 ? void 0 : (_site$deployment2 = site.deployment) === null || _site$deployment2 === void 0 ? void 0 : _site$deployment2.badgeImage,
    name: "deployment.badgeImage",
    onChange: handleChange
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "Badge Link",
    value: site === null || site === void 0 ? void 0 : (_site$deployment3 = site.deployment) === null || _site$deployment3 === void 0 ? void 0 : _site$deployment3.badgeLink,
    name: "deployment.badgeLink",
    onChange: handleChange
  }), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    loading: loading === 'deployment',
    onClick: function onClick() {
      return handleUpdate({
        deployment: site === null || site === void 0 ? void 0 : site.deployment
      }, 'deployment');
    },
    children: "Update",
    type: "primary"
  }))), /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Build"
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 20
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "Api Key",
    value: site === null || site === void 0 ? void 0 : site.apiKey,
    name: "apiKey",
    disabled: true
  }), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    loading: loading === 'apikey',
    onClick: function onClick() {
      return handleUpdate({
        apiKey: true
      }, 'apikey');
    },
    children: "Regenerate",
    type: "primary"
  }))), /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "API keys"
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 20
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    label: "Google Maps API Key",
    value: site === null || site === void 0 ? void 0 : site.googleMapsApi,
    name: "googleMapsApi",
    onChange: handleChange
  }), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    loading: loading === 'general',
    onClick: function onClick() {
      return handleUpdate({
        googleMapsApi: site.googleMapsApi
      }, 'general');
    },
    children: "Update",
    type: "primary"
  }))), /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: 'Editor Sidebar'
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 20
  }, /*#__PURE__*/_react.default.createElement(_Select.default, {
    label: "Position",
    value: site === null || site === void 0 ? void 0 : (_site$editorOptions = site.editorOptions) === null || _site$editorOptions === void 0 ? void 0 : (_site$editorOptions$s = _site$editorOptions.sidebar) === null || _site$editorOptions$s === void 0 ? void 0 : _site$editorOptions$s.position,
    onChange: function onChange(v) {
      return handleChangeSelect(v, 'editorOptions.sidebar.position');
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
    value: "left",
    children: "Left"
  }), /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
    value: "right",
    children: "Right"
  })), /*#__PURE__*/_react.default.createElement(_Select.default, {
    label: "Style",
    value: site === null || site === void 0 ? void 0 : (_site$editorOptions2 = site.editorOptions) === null || _site$editorOptions2 === void 0 ? void 0 : (_site$editorOptions2$ = _site$editorOptions2.sidebar) === null || _site$editorOptions2$ === void 0 ? void 0 : _site$editorOptions2$.style,
    onChange: function onChange(v) {
      return handleChangeSelect(v, 'editorOptions.sidebar.style');
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
    value: "inline",
    children: "Inline"
  }), /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
    value: "overflow",
    children: "Overflow"
  }), /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
    value: "scale",
    children: "Scale"
  })), /*#__PURE__*/_react.default.createElement(_Select.default, {
    label: "Default Status",
    value: site === null || site === void 0 ? void 0 : (_site$editorOptions3 = site.editorOptions) === null || _site$editorOptions3 === void 0 ? void 0 : (_site$editorOptions3$ = _site$editorOptions3.sidebar) === null || _site$editorOptions3$ === void 0 ? void 0 : _site$editorOptions3$.defaultOpen,
    onChange: function onChange(v) {
      return handleChangeSelect(v, 'editorOptions.sidebar.defaultOpen');
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
    value: true,
    children: "Open"
  }), /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
    value: false,
    children: "Closed"
  })), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    loading: loading === 'editorOptions',
    onClick: function onClick() {
      return handleUpdate({
        editorOptions: site === null || site === void 0 ? void 0 : site.editorOptions
      }, 'editorOptions');
    },
    children: "Update",
    type: "primary"
  })))));
};

var _default = GeneralSettings;
exports.default = _default;